module.exports = __webpack_public_path__ + "img/1fd3d48.svg";